module.exports = __webpack_public_path__ + "img/5.ff8637f0.svg";